import { useCallback, useEffect, useRef, useState } from "react";
import { CommunitySection } from "../../pages/community/enums/CommunitySection";
import { CommunityDiscussion } from "../../pages/community/models/CommunityDiscuss";
import { getCommunityDiscussions } from "../../services/communityService";
import { ApiArrayResponseModel } from "./models/ApiResponseModel";
import { DiscussionListModel } from "./models/DiscussionListModel";
import { useSearch } from "./useSearch";

export const useDiscussions = (section: CommunitySection, search: string, page: number = 1, limit: number = 10) => {
    const [loading, setLoading] = useState(true);
    const isMountedRef = useRef(true);
    const [data, setData] = useState<ApiArrayResponseModel<CommunityDiscussion> | null>(null);
    const searchValue = useSearch(search, 500);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    const load = useCallback(async () => {
        try {
            setLoading(true);
            const offset = (page - 1) * limit;
            const _data: ApiArrayResponseModel<DiscussionListModel> = await getCommunityDiscussions
            (
                section === CommunitySection.mastermindCircles ? 'circle': 'forum', 
                searchValue, 
                "published",
                limit,
                offset
            );

            if(!isMountedRef.current)
                return;
            const _list = _data.results.map(r => ({
                id: r.id,
                author: r.author,
                avatar: r.avatar,
                comments: r.comments,
                details: r.details,
                members: r.members,
                tags: r.tags,
                title: r.title,
                host: r.host,
                notifications: r.notifications,
                memberComments: r.memberComments
            })) as CommunityDiscussion[];
            setData({
                count: _data.count,
                next: _data.next as any,
                previous: _data.previous as any,
                results: _list
            });
        }
        finally {
            setLoading(false);
        }
    }, [section, searchValue, page, limit]);

    useEffect(() => {
        load();
    }, [load]);

    return {  loading, data };
}